import { useState, useCallback, useEffect } from 'react';

const API = 'https://tcio-api.onrender.com';

const styles = {
  container: { padding: '24px', maxWidth: '1200px', margin: '0 auto' },
  header: { marginBottom: '24px' },
  title: { fontSize: '22px', fontWeight: '700', color: '#1e293b', margin: 0 },
  subtitle: { fontSize: '13px', color: '#64748b', marginTop: '4px' },

  searchRow: { display: 'flex', gap: '12px', marginBottom: '28px', alignItems: 'center' },
  searchInput: {
    flex: 1, maxWidth: '420px', padding: '10px 16px', fontSize: '15px',
    border: '1px solid #cbd5e1', borderRadius: '8px', outline: 'none',
    boxShadow: '0 1px 3px rgba(0,0,0,0.06)'
  },
  searchBtn: {
    padding: '10px 22px', background: '#2563eb', color: '#fff',
    border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px',
    fontWeight: '600'
  },
  hint: { fontSize: '12px', color: '#94a3b8' },

  resultsCount: { fontSize: '13px', color: '#64748b', marginBottom: '12px' },

  table: { width: '100%', borderCollapse: 'collapse', background: '#fff', borderRadius: '10px', overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' },
  th: { background: '#f8fafc', padding: '11px 14px', textAlign: 'left', fontSize: '11px', fontWeight: '700', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em', borderBottom: '1px solid #e2e8f0' },
  td: { padding: '11px 14px', fontSize: '13px', color: '#334155', borderBottom: '1px solid #f1f5f9' },

  statusBadge: (status) => ({
    display: 'inline-block', padding: '2px 8px', borderRadius: '999px', fontSize: '11px', fontWeight: '600',
    background: status === 'Admitted' ? '#dcfce7' : status === 'Inquiry' ? '#fef9c3' : '#f1f5f9',
    color: status === 'Admitted' ? '#15803d' : status === 'Inquiry' ? '#854d0e' : '#475569',
  }),

  overlay: {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.35)', zIndex: 1000,
    display: 'flex', justifyContent: 'flex-end'
  },
  panel: {
    width: '580px', height: '100vh', background: '#fff', overflowY: 'auto',
    boxShadow: '-4px 0 24px rgba(0,0,0,0.12)', display: 'flex', flexDirection: 'column'
  },
  panelHeader: {
    padding: '20px 24px', borderBottom: '1px solid #e2e8f0',
    display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start',
    position: 'sticky', top: 0, background: '#fff', zIndex: 10
  },
  panelName: { fontSize: '18px', fontWeight: '700', color: '#1e293b' },
  panelSub: { fontSize: '12px', color: '#64748b', marginTop: '2px' },
  closeBtn: {
    background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer',
    color: '#94a3b8', padding: '0 4px', lineHeight: 1
  },
  panelBody: { padding: '20px 24px', flex: 1 },

  section: { marginBottom: '24px' },
  sectionTitle: {
    fontSize: '11px', fontWeight: '700', color: '#94a3b8', textTransform: 'uppercase',
    letterSpacing: '0.08em', marginBottom: '10px', paddingBottom: '6px',
    borderBottom: '1px solid #f1f5f9'
  },
  grid2: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' },
  fieldLabel: { fontSize: '10px', fontWeight: '600', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '2px' },
  fieldValue: { fontSize: '13px', color: '#1e293b', fontWeight: '500' },

  episodeCard: {
    background: '#f8fafc', borderRadius: '8px', padding: '12px 14px',
    marginBottom: '8px', border: '1px solid #e2e8f0'
  },
  episodeRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  episodeFacility: { fontSize: '13px', fontWeight: '600', color: '#1e293b' },
  episodeDates: { fontSize: '12px', color: '#64748b', marginTop: '2px' },
  episodeLOC: {
    fontSize: '11px', fontWeight: '700', padding: '2px 8px', borderRadius: '999px',
    background: '#dbeafe', color: '#1d4ed8'
  },

  emptyState: { textAlign: 'center', padding: '60px 0', color: '#94a3b8' },
  emptyIcon: { fontSize: '40px', marginBottom: '12px' },
  emptyText: { fontSize: '14px' },
  noResults: { textAlign: 'center', padding: '40px', color: '#94a3b8', fontSize: '14px' },
  loadingSpinner: { textAlign: 'center', padding: '40px', color: '#94a3b8', fontSize: '14px' },

  // PLV styles
  plvHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' },
  matchBadge: (method) => ({
    display: 'inline-flex', alignItems: 'center', gap: '4px',
    padding: '3px 10px', borderRadius: '999px', fontSize: '11px', fontWeight: '700',
    background: method === 'member_id' ? '#dcfce7' : method === 'name_dob' ? '#fef9c3' : '#f1f5f9',
    color: method === 'member_id' ? '#15803d' : method === 'name_dob' ? '#854d0e' : '#475569',
  }),

  totalBox: {
    background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: '8px',
    padding: '14px 16px', marginBottom: '12px',
    display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px'
  },
  totalItem: { textAlign: 'center' },
  totalLabel: { fontSize: '10px', fontWeight: '600', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '4px' },
  totalValue: { fontSize: '16px', fontWeight: '800', color: '#15803d' },

  payerTable: { width: '100%', borderCollapse: 'collapse', fontSize: '12px' },
  payerTh: { textAlign: 'left', padding: '6px 8px', color: '#94a3b8', fontWeight: '700', fontSize: '10px', textTransform: 'uppercase', borderBottom: '1px solid #e2e8f0' },
  payerTd: { padding: '7px 8px', borderBottom: '1px solid #f1f5f9', color: '#334155' },

  noMatchBox: {
    background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px',
    padding: '14px 16px'
  },
  noMatchText: { fontSize: '13px', color: '#64748b' },
};

function fmt(date) {
  if (!date) return '—';
  try {
    const s = String(date).slice(0, 10);
    const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    const dt = m ? new Date(+m[1], +m[2]-1, +m[3]) : new Date(date);
    return dt.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  }
  catch { return '—'; }
}

function fmtPhone(p) {
  if (!p) return '—';
  const d = p.replace(/\D/g, '');
  if (d.length === 10) return `(${d.slice(0,3)}) ${d.slice(3,6)}-${d.slice(6)}`;
  if (d.length === 11 && d[0] === '1') return `(${d.slice(1,4)}) ${d.slice(4,7)}-${d.slice(7)}`;
  return p;
}

function fmtMoney(n) {
  if (!n && n !== 0) return '$0';
  return '$' + parseFloat(n).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}

function fmtRep(rep) {
  if (!rep) return '—';
  const repMap = {
    'twestfall':   'Tiffany Westfall',
    'twerring':    'Taryn Werring',
    'amarquez':    'Andrew Marquez',
    'jaclyn':      'Jaclyn Hicks',
    'jcodd':       'Jade Codd',
    'zfashempour': 'Zac Fashempour',
    'acarlsen':    'Aurora Carlsen',
    'nluke':       'Nicole Luke',
    'bdeeble':     'Bruce Deeble',
    'twilliams':   'Tina Williams',
  };
  const key = rep.includes('@') ? rep.split('@')[0].toLowerCase() : rep.toLowerCase();
  if (repMap[key]) return repMap[key];
  return rep.charAt(0).toUpperCase() + rep.slice(1);
}

function fmtSource(c) {
  return c.referral_source || c.lead_source || c.campaign_source || '—';
}

function safe(val) {
  return (val !== null && val !== undefined && val !== '') ? val : '—';
}

function matchLabel(method) {
  if (method === 'member_id') return '✓ Verified via Member ID';
  if (method === 'name_dob') return '~ Matched via Name + DOB';
  return 'No match found';
}

export default function Alumni({ user }) {
  const [query, setQuery] = useState('');
  const [alumniCount, setAlumniCount] = useState(null);
  useEffect(() => {
    const token = localStorage.getItem('tcio_token');
    fetch(`${API}/api/alumni/stats`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json()).then(j => { if (j.ok) setAlumniCount(j.count); }).catch(() => {});
  }, []);
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(null);
  const [detail, setDetail] = useState(null);
  const [detailLoading, setDetailLoading] = useState(false);

  const search = useCallback(async (q) => {
    const term = (q || query).trim();
    if (term.length < 2) return;
    setLoading(true);
    setResults(null);
    try {
      const token = localStorage.getItem('tcio_token');
      const res = await fetch(`${API}/api/alumni/search?q=${encodeURIComponent(term)}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await res.json();
      setResults(data.contacts || []);
    } catch (err) {
      console.error(err);
      setResults([]);
    } finally {
      setLoading(false);
    }
  }, [query]);

  const openDetail = async (contact) => {
    setSelected(contact);
    setDetail(null);
    setDetailLoading(true);
    try {
      const token = localStorage.getItem('tcio_token');
      const res = await fetch(`${API}/api/alumni/${contact.id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await res.json();
      setDetail(data);
    } catch (err) {
      console.error(err);
      setDetail({ contact, episodes: [], payments: [], matchMethod: 'none', matchScore: 0 });
    } finally {
      setDetailLoading(false);
    }
  };

  const closePanel = () => { setSelected(null); setDetail(null); };
  const handleKey = (e) => { if (e.key === 'Enter') search(); };

  return (
    <div style={styles.container}>

      {/* Header */}
      <div style={styles.header}>
        <div style={styles.title}>Alumni Search</div>
        <div style={styles.subtitle}>Search {alumniCount == null ? '' : alumniCount.toLocaleString() + ' '}historical records — name or phone number</div>
      </div>

      {/* Search */}
      <div style={styles.searchRow}>
        <input
          style={styles.searchInput}
          placeholder="Search by name or phone..."
          value={query}
          onChange={e => setQuery(e.target.value)}
          onKeyDown={handleKey}
          autoFocus
        />
        <button style={styles.searchBtn} onClick={() => search()}>Search</button>
        <span style={styles.hint}>Min 2 characters &nbsp;·&nbsp; Press Enter to search</span>
      </div>

      {loading && <div style={styles.loadingSpinner}>Searching...</div>}

      {!loading && results === null && (
        <div style={styles.emptyState}>
          <div style={styles.emptyIcon}>🔍</div>
          <div style={styles.emptyText}>Enter a patient name or phone number to search alumni records</div>
        </div>
      )}

      {!loading && results !== null && results.length === 0 && (
        <div style={styles.noResults}>No records found for "{query}"</div>
      )}

      {/* Results Table */}
      {!loading && results !== null && results.length > 0 && (
        <>
          <div style={styles.resultsCount}>{results.length} record{results.length !== 1 ? 's' : ''} found</div>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>Name</th>
                <th style={styles.th}>DOB</th>
                <th style={styles.th}>Phone</th>
                <th style={styles.th}>Facility</th>
                <th style={styles.th}>Source</th>
                <th style={styles.th}>Admit Date</th>
                <th style={styles.th}>LOC</th>
                <th style={styles.th}>Rep</th>
                <th style={styles.th}>Status</th>
              </tr>
            </thead>
            <tbody>
              {results.map((c, i) => (
                <tr
                  key={c.id || i}
                  style={{ cursor: 'pointer' }}
                  onClick={() => openDetail(c)}
                  onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'}
                  onMouseLeave={e => e.currentTarget.style.background = ''}
                >
                  <td style={{ ...styles.td, fontWeight: '600', color: '#1e293b' }}>{c.first_name} {c.last_name}</td>
                  <td style={styles.td}>{fmt(c.dob)}</td>
                  <td style={styles.td}>{fmtPhone(c.phone)}</td>
                  <td style={styles.td}>{c.facility_name || '—'}</td>
                  <td style={styles.td}>{fmtSource(c)}</td>
                  <td style={styles.td}>{fmt(c.admission_date)}</td>
                  <td style={styles.td}>{c.loc || '—'}</td>
                  <td style={styles.td}>{fmtRep(c.admissions_rep)}</td>
                  <td style={styles.td}>
                    <span style={styles.statusBadge(c.admitted_status)}>{c.admitted_status || 'Unknown'}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}

      {/* Detail Panel */}
      {selected && (
        <div style={styles.overlay} onClick={e => e.target === e.currentTarget && closePanel()}>
          <div style={styles.panel}>

            <div style={styles.panelHeader}>
              <div>
                <div style={styles.panelName}>{selected.first_name} {selected.last_name}</div>
                <div style={styles.panelSub}>
                  {selected.facility_name || 'Unknown Facility'} &nbsp;·&nbsp; {selected.admitted_status || 'Unknown Status'}
                </div>
              </div>
              <button style={styles.closeBtn} onClick={closePanel}>✕</button>
            </div>

            <div style={styles.panelBody}>

              {detailLoading && <div style={styles.loadingSpinner}>Loading record...</div>}

              {!detailLoading && (!detail || !detail.contact) && (
                <div style={{ fontSize: '13px', color: '#ef4444', padding: '20px 0' }}>
                  Failed to load record. Please try again.
                </div>
              )}

              {!detailLoading && detail && detail.contact && (
                <>
                  {/* Contact Info */}
                  <div style={styles.section}>
                    <div style={styles.sectionTitle}>Contact Info</div>
                    <div style={styles.grid2}>
                      <div>
                        <div style={styles.fieldLabel}>Date of Birth</div>
                        <div style={styles.fieldValue}>{fmt(detail.contact.dob)}</div>
                      </div>
                      <div>
                        <div style={styles.fieldLabel}>Phone</div>
                        <div style={styles.fieldValue}>{fmtPhone(detail.contact.phone)}</div>
                      </div>
                      <div>
                        <div style={styles.fieldLabel}>Email</div>
                        <div style={styles.fieldValue}>{safe(detail.contact.email)}</div>
                      </div>
                      <div>
                        <div style={styles.fieldLabel}>Gender</div>
                        <div style={styles.fieldValue}>{safe(detail.contact.gender)}</div>
                      </div>
                    </div>
                  </div>

                  {/* Historical Admission Record */}
                  <div style={styles.section}>
                    <div style={styles.sectionTitle}>Historical Admission Record</div>
                    <div style={styles.grid2}>
                      <div>
                        <div style={styles.fieldLabel}>Facility</div>
                        <div style={styles.fieldValue}>{safe(detail.contact.facility_name)}</div>
                      </div>
                      <div>
                        <div style={styles.fieldLabel}>LOC</div>
                        <div style={styles.fieldValue}>{safe(detail.contact.loc)}</div>
                      </div>
                      <div>
                        <div style={styles.fieldLabel}>Admit Date</div>
                        <div style={styles.fieldValue}>{fmt(detail.contact.admission_date)}</div>
                      </div>
                      <div>
                        <div style={styles.fieldLabel}>Discharge Date</div>
                        <div style={styles.fieldValue}>{fmt(detail.contact.discharge_date)}</div>
                      </div>
                      <div>
                        <div style={styles.fieldLabel}>LOS</div>
                        <div style={styles.fieldValue}>{detail.contact.los_days ? `${detail.contact.los_days} days` : '—'}</div>
                      </div>
                      <div>
                        <div style={styles.fieldLabel}>Discharge Type</div>
                        <div style={styles.fieldValue}>{safe(detail.contact.discharge_type)}</div>
                      </div>
                      <div>
                        <div style={styles.fieldLabel}>Referral Source</div>
                        <div style={styles.fieldValue}>{fmtSource(detail.contact)}</div>
                      </div>
                      <div>
                        <div style={styles.fieldLabel}>Admissions Rep</div>
                        <div style={styles.fieldValue}>{fmtRep(detail.contact.admissions_rep)}</div>
                      </div>
                      <div>
                        <div style={styles.fieldLabel}>Insurance</div>
                        <div style={styles.fieldValue}>{safe(detail.contact.insurance_company)}</div>
                      </div>
                      <div>
                        <div style={styles.fieldLabel}>Member ID</div>
                        <div style={styles.fieldValue}>{safe(detail.contact.member_id)}</div>
                      </div>
                    </div>
                  </div>

                  {/* TCIO Episodes */}
                  {detail.episodes && detail.episodes.length > 0 && (
                    <div style={styles.section}>
                      <div style={styles.sectionTitle}>TCIO Episodes ({detail.episodes.length})</div>
                      {detail.episodes.map((ep, i) => (
                        <div key={i} style={styles.episodeCard}>
                          <div style={styles.episodeRow}>
                            <div>
                              <div style={styles.episodeFacility}>{ep.facility_name}</div>
                              <div style={styles.episodeDates}>
                                {fmt(ep.admit_date)} → {ep.discharge_date ? fmt(ep.discharge_date) : 'Current'}
                              </div>
                            </div>
                            <span style={styles.episodeLOC}>{ep.loc || '—'}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Patient Lifetime Value */}
                  <div style={styles.section}>
                    <div style={styles.plvHeader}>
                      <div style={styles.sectionTitle} style={{ margin: 0, padding: 0, border: 'none' }}>Patient Lifetime Value</div>
                      <span style={styles.matchBadge(detail.matchMethod)}>
                        {matchLabel(detail.matchMethod)}
                      </span>
                    </div>
                    <div style={{ borderBottom: '1px solid #f1f5f9', marginBottom: '12px', marginTop: '6px' }} />

                    {/* VERIFIED or NAME MATCH — show data */}
                    {(detail.matchMethod === 'member_id' || detail.matchMethod === 'name_dob') && detail.claimCount > 0 && (
                      <>
                        {/* Summary totals */}
                        <div style={styles.totalBox}>
                          <div style={styles.totalItem}>
                            <div style={styles.totalLabel}>Total Collected</div>
                            <div style={styles.totalValue}>{fmtMoney(detail.totalCollected)}</div>
                          </div>
                          <div style={styles.totalItem}>
                            <div style={styles.totalLabel}>Total Billed</div>
                            <div style={{ ...styles.totalValue, color: '#1d4ed8' }}>{fmtMoney(detail.totalBilled)}</div>
                          </div>
                          <div style={styles.totalItem}>
                            <div style={styles.totalLabel}>Claims</div>
                            <div style={{ ...styles.totalValue, color: '#7c3aed' }}>{detail.claimCount}</div>
                          </div>
                        </div>

                        {/* Payer breakdown */}
                        {detail.payerSummary && detail.payerSummary.length > 0 && (
                          <table style={styles.payerTable}>
                            <thead>
                              <tr>
                                <th style={styles.payerTh}>Payer</th>
                                <th style={{ ...styles.payerTh, textAlign: 'right' }}>Claims</th>
                                <th style={{ ...styles.payerTh, textAlign: 'right' }}>Collected</th>
                                <th style={{ ...styles.payerTh, textAlign: 'right' }}>Billed</th>
                              </tr>
                            </thead>
                            <tbody>
                              {detail.payerSummary.map((p, i) => (
                                <tr key={i}>
                                  <td style={styles.payerTd}>{p.payer_name}</td>
                                  <td style={{ ...styles.payerTd, textAlign: 'right' }}>{p.claims}</td>
                                  <td style={{ ...styles.payerTd, textAlign: 'right', fontWeight: '600', color: '#15803d' }}>{fmtMoney(p.collected)}</td>
                                  <td style={{ ...styles.payerTd, textAlign: 'right', color: '#64748b' }}>{fmtMoney(p.billed)}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        )}
                      </>
                    )}

                    {/* NO MATCH — show message */}
                    {detail.matchMethod === 'none' && (
                      <div style={styles.noMatchBox}>
                        <div style={styles.noMatchText}>
                          No verified claims data found for this patient. They may not have a member ID on file, or their episode predates the current claims data window.
                        </div>
                      </div>
                    )}
                  </div>

                </>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}